// extracted by mini-css-extract-plugin
export default {"wiringInstructionsImage":"Rooms_wiringInstructionsImage__vVpgL"};